import InveriteContainer from './Inverite.container';

export default InveriteContainer;
